import Entity from "./entity";

export default class ProductHistory extends Entity<number> {
  userId: number;
  userName: string;
  userFullName: string;
  changeTime: Date;
  items: Array<PropertyChange>;
}

class PropertyChange {
  propertyName: string;
  infoName: string;
  oldValue: string;
  newValue: string;
}
